import { sendPost } from '../http.js'
// POST  user/dy/group/edit/scope 编辑挂载课程
// id 群聊ID
// product_ids 课程ID 数组

// POST  user/dy/group/scope 群聊挂载得课程ID
// id 群聊ID
const api = {
	'dyGroupAdd': '/user/dy/group/addv2',
    'dyGroupIndex': '/user/dy/group/indexv2',
    'dyEditStatus': '/user/dy/group/edit/status',
    'groupCourseList': '/user/dy/group/course/option',
    'groupEdit': '/user/dy/group/edit/scope',
    'groupScope': '/user/dy/group/scope',
	'groupStatus': '/user/dy/group/imgstatus',
	// 'groupAuthInfo': '/user/dy/group/logininfo',
    'groupAuthInfo': '/user/dy/group/logininfov2',
	'groupUnbind': '/user/dy/group/dellogin',
	'auditList': '/user/dy/group/audit/list',
    'auditEdit': 'user/dy/group/audit/edit',
    'groupDel': '/user/dy/group/del'
}
export default {
	dyGroupAdd(params) {
	    return sendPost(api.dyGroupAdd, params)
	},
    dyGroupIndex(params) {
        return sendPost(api.dyGroupIndex, params)
    },
    dyEditStatus(params) {
        return sendPost(api.dyEditStatus, params)
    },
    groupCourseList(params) {
        return sendPost(api.groupCourseList, params)
    },
    groupEdit(params) {
        return sendPost(api.groupEdit, params)
    },
    groupScope(params) {
        return sendPost(api.groupScope, params)
    },
	groupStatus(params) {
	    return sendPost(api.groupStatus, params)
	},
	groupAuthInfo(params) {
	    return sendPost(api.groupAuthInfo, params)
	},
	groupUnbind(params) {
	    return sendPost(api.groupUnbind, params)
	},
    auditList(params) {
        return sendPost(api.auditList, params)
    },
    auditEdit(params){
        return sendPost(api.auditEdit, params)
    },
    groupDel(params) {
        return sendPost(api.groupDel, params)
    }
}
